import _ from 'lodash'
import { eLearningModuleDownloadFile } from 'src/utils/apiPath'
import { downloadGetFile } from 'src/services/util'
import {
  setSelectedLesson,
  setVideoState,
  startLoading,
  stopLoading,
} from 'src/redux/slices/eLearning/learning'

export const handleSelectModule = (data) => (dispatch) => {
  dispatch(startLoading())
  dispatch(setVideoState({ playing: false }))
  setTimeout(() => {
    dispatch(setSelectedLesson(data))
    dispatch(stopLoading())
  }, 1500)
}

export const formatDurationToMinute = (duration) => {
  if (_.isNil(duration)) return '00:00'
  const date = new Date(duration.toFixed() * 1000)

  const hours = date.getUTCHours()
  const minutes = padTo2Digits(date.getUTCMinutes())
  const seconds = padTo2Digits(date.getUTCSeconds())

  if (hours) {
    return `${hours}:${minutes}:${seconds}`
  } else return `${minutes}:${seconds}`
}

export function padTo2Digits(num) {
  return num.toString().padStart(2, '0')
}

export const handleDownloadFile = (file) => (dispatch) => {
  const key = _.get(file, 'file', '')
  const fileName = _.get(file, 'displayName', _.get(file, 'oldFileName', ''))
  const url = key.startsWith('ilearn/')
    ? `/file/${key}`
    : `${eLearningModuleDownloadFile}/${key.replace('/e-learning/module/', '')}`
  dispatch(downloadGetFile({ url, fileName }))
}
